import { toast } from 'react-toastify'
import LinkIcon from '@mui/icons-material/Link'
import notificationToast from 'helpers/notificationToast'

// navigator.clipboard.writeText can reject with a NotAllowedError in some
// browser/permission states (seen in headless Chrome e2e runs) - caught and
// logged rather than left as an unhandled rejection, which otherwise trips a
// dev-server runtime-error overlay covering the page.
const copyToClipboard = (text: string, message: string): void => {
  navigator.clipboard.writeText(text).catch(error => {
    console.error('Failed to copy to clipboard:', error)
  })
  notificationToast(<LinkIcon />, toast.TYPE.INFO, message)
}

export default copyToClipboard
